
@if (controller.isLibrary() === false) {
  <div class="complete-training-overlay">
  </div>
}


<div class="content-library" [class.themed]="useThemes">

  @if (isHrUser()) {
    <app-back-button (backClick)="goBack()"></app-back-button>
  }

  @if (!useThemes) {
    <h2 data-testid="library-heading">Content library</h2>
  }

  @if (useThemes) {

    <div class="theme-layout">

      <div class="theme-sidebar" data-testid="theme-sidebar">
        <div class="theme-sidebar-label">Heritage themes</div>



        @for (theme of themes; track theme.label) {
          <button type="button" class="theme-row" [class.active]="activeTheme === theme.label"
            [style.border-left-color]="activeTheme === theme.label ? theme.color : 'transparent'"
            (click)="selectTheme(theme.label)">
            <span class="theme-dot" [style.background]="theme.color"></span>
            <span class="theme-row-label">{{ theme.label }}</span>
            <span class="theme-row-count">{{ theme.count }}</span>
          </button>
        }
      </div>

      <div class="theme-main">

        <div class="theme-header">
          <div class="theme-header-bar" [style.background]="getActiveThemeColor()"></div>
          <div>
            <h3 class="theme-header-title">{{ activeTheme }}</h3>
            <div class="theme-header-count">{{ getActiveThemeCount() }} resources available</div>
          </div>
        </div>

        <div class="content-filter pill">
          <div (click)="filter($event, 'all')" class="filter-button all selected">
            all
          </div>

          @for (filterButton of filterButtons; track filterButton) {
            <div (click)="filter($event, filterButton.type)"
              [ngClass]="['filter-button',  'type-' + filterButton.type]">
              {{filterButton.label}}
            </div>
          }
        </div>

        <div class="contents grid">
          @if (filteredContent.length == 0) {
            <div>
              Sorry, no additional content is available at this time.
            </div>
          }

          @for (content of filteredContent; track content) {
            <div data-testid="content-card" class="content-card" (click)="loadLibraryContent(content.hcontent_id)">
              <div class="content-thumb" [ngStyle]="{'background-image':getImageUrl(content)}">
                <div class="content-thumb-play">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
                    <path d="M3 1.5l8.5 5L3 11.5V1.5z" fill="rgba(255,255,255,0.85)"></path>
                  </svg>
                </div>
                @if (content.complete) {
                  <div class="content-thumb-complete">
                    <img src="../../assets/img/correct.svg" alt="Completed" />
                  </div>
                }
              </div>
              <div class="content-info">
                <div class="badges">
                  <div [ngClass]="['badge-type', 'badge-type-' + getContentType(content, true)]">
                    {{ getContentType(content) }}
                  </div>
                  @if (getDuration(content)) {
                    <span class="duration-label">{{ getDuration(content) }} mins</span>
                  }
                </div>
                <h5 data-testid="content-card-title">{{ content.metadata.properties.header }}</h5>
              </div>
            </div>
          }
        </div>

      </div>
    </div>

  } @else {

    <div class="content-filter">

      <div (click)="filter($event, 'all')" class="filter-button all selected">
        all
      </div>

      <div class="separator"></div>

      @for (filterButton of filterButtons; track filterButton) {
        <div (click)="filter($event, filterButton.type)"
          [ngClass]="['filter-button',  'type-' + filterButton.type]">
          {{filterButton.label}}
        </div>
      }
    </div>


    <div class="contents">

      @if (filteredContent.length == 0) {
        <div>
          Sorry, no additional content is available at this time.
        </div>
      }

      @for (content of filteredContent; track content) {
        <div data-testid="content-card" class="content-card" (click)="loadLibraryContent(content.hcontent_id)"
          [ngStyle]="{'background-image':getImageUrl(content)}">
          <div class="content-bottom">
            <div class="badges">
              <div [ngClass]="['badge-type', 'badge-type-' + getContentType(content, true)]">
                {{ getContentType(content) }}
              </div>
              @if (getDuration(content)) {
                <div class="badge-type duration">
                  {{ getDuration(content) }} mins
                </div>
              }
              @if (content.complete) {
                <div class="complete">
                  <img src="../../assets/img/correct.svg" />
                </div>
              }
            </div>
            <h5 data-testid="content-card-title"> {{content.metadata.properties.header}} </h5>
            <p>
              {{ content.metadata.properties.slug}}
            </p>
          </div>
        </div>
      }
    </div>

  }
</div>
